import styled from 'styled-components'

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const InputContainer = styled.div``

export const Title = styled.div`
  display: inline-block;
  width: 100%;
  border-bottom: 1px solid #cecece;

  > span {
  }
`

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  align-self: flex-end;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`
